import { useQueries } from '@tanstack/react-query';
import { Dropdown } from 'antd';
import { LuHistory } from 'react-icons/lu';
import { getVideoResults } from '@utils/api/videoProjects';
import { Chip } from '../components/overlay/CountPanel';

/**
 * The versions of a project's analysis once it was run again with examples: v1 (the first run), v2 … (runs with
 * what people taught it). Picking one shows it; each keeps its own corrections. Hidden for a project with one run.
 */

const VersionPicker = ({ projectUuid, jobUuids = [], current, onPick }) => {
	const recent = jobUuids.slice(-6);
	const results = useQueries({
		queries: recent.map(id => ({
			queryKey: ['videoResults', projectUuid, id],
			queryFn: () => getVideoResults(projectUuid, id),
			staleTime: 30000,
		})),
	});
	const jobs = results.map(r => r.data?.data).filter(Boolean);
	if (!jobs.some(j => (j.analysis_version || 1) > 1)) return null;
	const label = j =>
		`v${j.analysis_version || 1} · ${j.parent_job_uuid ? 'with your examples' : 'first run'}${
			j.job_status === 'running' || j.job_status === 'pending' ? ' · running' : ''
		}`;
	const shown = jobs.find(j => j.uuid === current);
	return (
		<Dropdown
			trigger={['click']}
			menu={{
				items: jobs.map(j => ({ key: j.uuid, label: label(j) })),
				selectable: true,
				selectedKeys: current ? [current] : [],
				onClick: ({ key }) => onPick(key),
			}}>
			<Chip type="button">
				<LuHistory /> {shown ? `v${shown.analysis_version || 1}` : 'Versions'}
			</Chip>
		</Dropdown>
	);
};

export default VersionPicker;
